import React, { useEffect, useMemo, useState } from "react";
import AnimatedNumber from "./AnimatedNumber";
import CountdownTimer from "../../components/countdown";
import CountDownTimerGive from "./CountDownTimer";
import { useAppSelector } from "../../hooks/useReduxMethods";
import moment from "moment-timezone";
const GiveawayCard = ({
  image,
  title,
  fullPage,
  description,
  startDate,
  intervalDays,
  //   days,
  //   hours,
  bottomText,
  remainingDays,
  //   minutes,
  gradient,
}) => {
  /** 
  const [seconds, setSeconds] = useState(60);
  const getBaghdadNow = () => {
    const baghdadDate = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Asia/Baghdad" })
    );
    return baghdadDate;
  };
  const targetDate = useMemo(() => {
    const now = getBaghdadNow();
    now.setSeconds(now.getSeconds() + remainingDays * 24 * 60 * 60);
    return now;
  }, [remainingDays]);

  const calculateTimeLeft = () => {
    const now = new Date().getTime();
    const future = targetDate.getTime();
    const diff = Math.max(0, future - now);

    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  };
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [prev, setPrev] = useState(timeLeft);
  useEffect(() => {
    const interval = setInterval(() => {
      const newTime = calculateTimeLeft();
      setPrev(timeLeft);
      setTimeLeft(newTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, calculateTimeLeft]);
  */
  const getTimeDiff = (startDate) => {
    const now = moment.tz("Asia/Baghdad");
    const target = moment.tz(startDate, "Asia/Baghdad");
    const diff = moment.duration(target.diff(now));

    if (diff.asSeconds() <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(diff.asDays()),
      hours: diff.hours(),
      minutes: diff.minutes(),
      seconds: diff.seconds(),
    };
  };
  const [timeLeft, setTimeLeft] = useState(getTimeDiff(startDate));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeDiff(startDate));
    }, 1000);
    return () => clearInterval(interval);
  }, [startDate]);

  const { days, hours, minutes, seconds } = timeLeft;
  return (
    <div
      className={`giveaway-card ${fullPage ? "fullpage" : ""} `}
      style={{ background: gradient }}
    >
      {!fullPage && (
        <div className="left-section">
          <img src={image} alt="Giveaway" className="giveaway-image" />
        </div>
      )}
      <div className="right-section">
        <p className="giveaway-title bold">{title}</p>
        <p className="giveaway-description">{description}</p>
        {fullPage && (
          <div className="left-section">
            <img src={image} alt="Giveaway" className="giveaway-image" />
          </div>
        )}

        {fullPage && (
          <div className="giveaway-remaining-days bold">
            <span>متبقي لسحبة السيارة</span>
          </div>
        )}
        <div className="giveaway-countdown">
          {/* <CountDownTimerGive targetDate="2025-06-03T19:00:00Z" /> */}
          <div
            style={{ borderRight: " 1px solid" }}
            className="giveaway-count-box"
          >
            <small>DAYS</small>
            <span className="bold">{String(days).padStart(2, "0")}</span>
          </div>
          <div
            style={{ borderRight: " 1px solid" }}
            className="giveaway-count-box"
          >
            <small>HOUR</small>
            <span className="bold">{String(hours).padStart(2, "0")}</span>
          </div>
          <div
            style={{ borderRight: " 1px solid" }}
            className="giveaway-count-box"
          >
            <small>MINUTES</small>
            <span className="bold">{String(minutes).padStart(2, "0")}</span>
          </div>
          <div className="giveaway-count-box">
            <small>Seconds</small>
            <span>
              <span className="bold">{String(seconds).padStart(2, "0")}</span>
              {/* <AnimatedNumber value={timeLeft.seconds} /> */}
            </span>
          </div>
        </div>

        <p className="giveaway-description bold">{bottomText}</p>
      </div>
    </div>
  );
};

export default GiveawayCard;
